import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: getInititalState(),
  reducers: {
    setStore: (state, action) => {
      state.store = action.payload;
    },
    setUserStores: (state, action) => {
      state.userStores = action.payload;
    },
    setBanksData: (state, action) => {
      state.banksData = action.payload;
    },
    setUser: (state, action) => {
      state.isLoggedIn = true;
      state.user = action?.payload;
      state.store = action?.payload?.store?.length > 0 ? { ...action.payload.store[0], ...(action?.payload?.store?.length === 1 && { isSelected: true }) } : null;
      state.userStores = action?.payload?.store;
      state.storesAreDisabled = action?.payload?.storesAreDisabled;
    },
  },
});

function getInititalState() {
  let state = {
    user: null,
    store: null,
    userStores: null,
    isLoggedIn: false,
    banksData: null,
  };
  return state;
}

export const { setStore, setUser, setUserStores, setBanksData } = userSlice.actions;

export default userSlice.reducer;
